/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button} from '@mui/material';

export const ActionsCell = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const ActionButton = styled(Button)(({theme}) => ({
  fontSize: '12px',
  justifyContent: 'flex-start',
  backgroundColor: 'transparent',
  border: 'none',
  color: theme.palette.figma_gray_light_4?.main,
  borderRadius: '8px',
  textAlign: 'left',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.palette.figma_gray_dark_4?.main,
    border: 'none',
  },
  '&.MuiButton-outlined': {
    border: 'none',
    '&:hover': {
      border: 'none',
    },
  },
}));
